export const recipes = [
  {
    id: 1,
    title: "Creamy Tuscan Chicken Pasta",
    description: "A delicious Italian-inspired dish with creamy garlic sauce and sun-dried tomatoes.",
    image: "/images/407.png",
    category: "pasta",
    prepTime: 15,
    cookTime: 25,
    servings: 4,
    difficulty: "Medium",
    ingredients: [
      "2 large chicken breasts, cut into strips",
      "8 oz fettuccine pasta",
      "3 cloves garlic, minced",
      "1 cup heavy cream",
      "1/2 cup chicken broth",
      "1/2 cup grated parmesan cheese",
      "1/2 cup sun-dried tomatoes, chopped",
      "2 cups fresh spinach",
      "1 tsp dried Italian herbs",
      "Salt and pepper to taste",
      "2 tbsp olive oil",
      "Fresh basil for garnish"
    ],
    instructions: [
      "Boil the pasta according to package instructions until al dente. Drain and set aside.",
      "Season chicken strips with salt, pepper, and Italian herbs.",
      "Heat olive oil in a large skillet over medium-high heat. Add chicken and cook until golden and cooked through, about 5-6 minutes. Remove and set aside.",
      "In the same skillet, add minced garlic and cook for 30 seconds until fragrant.",
      "Add the chicken broth and scrape up any browned bits from the bottom of the pan.",
      "Pour in the heavy cream and bring to a simmer. Stir in the parmesan cheese until melted.",
      "Add the sun-dried tomatoes and spinach, stirring until the spinach wilts.",
      "Return the chicken to the skillet and add the cooked pasta. Toss everything together until well coated.",
      "Garnish with fresh basil and additional parmesan cheese if desired."
    ],
    featured: true,
    popular: true
  },
  {
    id: 2,
    title: "Spaghetti Aglio e Olio",
    description: "A simple yet flavorful Italian pasta made with garlic, olive oil, and chili flakes.",
    image: "/images/404.png",
    category: "pasta",
    prepTime: 10,
    cookTime: 15,
    servings: 2,
    difficulty: "Easy",
    ingredients: [
      "200g spaghetti",
      "4 cloves garlic, thinly sliced",
      "1/4 cup extra virgin olive oil",
      "1 tsp red chili flakes",
      "Salt to taste",
      "Fresh parsley, chopped",
      "Grated parmesan cheese (optional)"
    ],
    instructions: [
      "Cook the spaghetti until al dente. Reserve some pasta water and drain.",
      "Heat olive oil in a pan over medium heat. Add garlic and chili flakes. Sauté until fragrant.",
      "Add the cooked pasta and toss to coat.",
      "Use reserved pasta water to loosen the sauce if needed.",
      "Season with salt and garnish with parsley and parmesan cheese."
    ],
    featured: true,
    popular: true
  },
  {
    id: 3,
    title: "Baked Ziti",
    description: "A comforting baked pasta dish loaded with cheese and marinara sauce.",
    image: "/images/405.png",
    category: "pasta",
    prepTime: 20,
    cookTime: 30,
    servings: 4,
    difficulty: "Medium",
    ingredients: [
      "300g ziti pasta",
      "2 cups marinara sauce",
      "1 cup ricotta cheese",
      "1.5 cups shredded mozzarella cheese",
      "1/2 cup grated parmesan",
      "1 egg",
      "1 tsp dried oregano",
      "Salt and pepper to taste"
    ],
    instructions: [
      "Preheat oven to 375°F (190°C).",
      "Cook ziti pasta until al dente. Drain.",
      "Mix ricotta, egg, salt, pepper, and oregano in a bowl.",
      "In a baking dish, layer pasta, marinara, ricotta mixture, and mozzarella.",
      "Repeat layers and top with parmesan.",
      "Bake for 25–30 minutes until bubbly and golden."
    ],
    featured: false,
    popular: true
  },
  {
    id: 4,
    title: "Penne alla Vodka",
    description: "Creamy tomato-based vodka sauce served over penne pasta, perfect for date night.",
    image: "/images/408.png",
    category: "pasta",
    prepTime: 10,
    cookTime: 20,
    servings: 3,
    difficulty: "Medium",
    ingredients: [
      "250g penne pasta",
      "2 tbsp olive oil",
      "2 cloves garlic, minced",
      "1/2 cup vodka",
      "1 cup tomato sauce",
      "3/4 cup heavy cream",
      "Salt and pepper to taste",
      "1/2 cup grated parmesan cheese",
      "Fresh basil for garnish"
    ],
    instructions: [
      "Cook penne until al dente and set aside.",
      "In a pan, heat olive oil and sauté garlic.",
      "Add vodka and let it reduce by half.",
      "Stir in tomato sauce and simmer for 5 minutes.",
      "Pour in cream and stir until smooth.",
      "Add cooked pasta and parmesan. Toss well.",
      "Garnish with fresh basil before serving."
    ],
    featured: true,
    popular: false
  },
  {
    id: 5,
    title: "Spinach and Feta Stuffed Shells",
    description: "Large pasta shells stuffed with spinach and feta cheese, baked in tomato sauce.",
    image: "/images/407.png",
    category: "pasta",
    prepTime: 25,
    cookTime: 30,
    servings: 4,
    difficulty: "Medium",
    ingredients: [
      "16 jumbo pasta shells",
      "1 cup ricotta cheese",
      "1 cup chopped cooked spinach",
      "1/2 cup crumbled feta cheese",
      "1 egg",
      "2 cups marinara sauce",
      "1/2 cup shredded mozzarella",
      "Salt and pepper to taste"
    ],
    instructions: [
      "Preheat oven to 375°F (190°C).",
      "Boil pasta shells and set aside to cool.",
      "Mix ricotta, spinach, feta, egg, salt, and pepper in a bowl.",
      "Stuff each shell with the mixture.",
      "Spread marinara in a baking dish, add shells, top with more sauce and cheese.",
      "Bake for 25–30 minutes until bubbly and golden."
    ],
    featured: false,
    popular: true
  },
  {
    id: 6,
    title: "Creamy Pesto Chicken Pasta",
    description: "A rich and creamy basil pesto pasta with tender chicken and cherry tomatoes.",
    image: "/images/409.png",
    category: "pasta",
    prepTime: 15,
    cookTime: 20,
    servings: 4,
    difficulty: "Medium",
    ingredients: [
      "2 chicken breasts, diced",
      "300g penne or fusilli pasta",
      "1/2 cup basil pesto",
      "1 cup cherry tomatoes, halved",
      "3/4 cup heavy cream",
      "2 tbsp olive oil",
      "Salt and pepper to taste",
      "Parmesan for garnish"
    ],
    instructions: [
      "Cook pasta until al dente, reserve some water, then drain.",
      "In a skillet, cook chicken in olive oil until golden.",
      "Add cherry tomatoes and cook for 2–3 minutes.",
      "Pour in cream and pesto, stir until combined.",
      "Toss in pasta and add some reserved water if needed.",
      "Garnish with parmesan and serve hot."
    ],
    featured: true,
    popular: true
  }
];
